import { render, staticRenderFns } from "./PdfTestView.vue?vue&type=template&id=5bf5e7ba&"
import script from "./PdfTestView.vue?vue&type=script&lang=js&"
export * from "./PdfTestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports